import type { SearchAPIParams } from '@/domainLogic/index.ts';
import type { MemSearchProductAccommodation } from '@/domainLogic/api/memsearch/typesMemsearch.ts';
import type { ProductAccommodation } from '@/domainLogic/types/typesProduct.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import type { StarfishIconRef } from '@/app/common/icons/starfish';

// TODO(MPH-847): interim local patches for sustainability_certificate. These types now live in
// src/domainLogic, so the field can be added there directly - no package release to wait for.
export type MemSearchAccommodationWithCertificate = MemSearchProductAccommodation & {
  sustainability_certificate?: boolean;
};

export type AccommodationWithCertificate = ProductAccommodation & {
  sustainabilityCertificate?: boolean;
};

export type SearchAPIParamsWithCertificate = SearchAPIParams & {
  sustainability_certificate?: number;
};

export const hasSustainabilityCertificate = (accommodation?: ProductAccommodation): boolean =>
  !!(accommodation as AccommodationWithCertificate | undefined)?.sustainabilityCertificate;

export const SUSTAINABILITY_CERTIFICATE_COPY = {
  cardLabel: 'vacation.oss.cards.sustainability_certificate',
  filterTitle: 'vacation.oss.filters.sustainability_certificate.title',
  filterText: 'vacation.oss.filters.sustainability_certificate.text',
} as const;

export const getSustainabilityCertificateLabel = (
  accommodation: ProductAccommodation | undefined,
  t: TranslationFunction
): string => (hasSustainabilityCertificate(accommodation) ? t(SUSTAINABILITY_CERTIFICATE_COPY.cardLabel) : '');

export const STAR_MEDAL_ICON: StarfishIconRef = {
  category: 'Rating and feedback',
  name: 'icon-star-medal',
  color: 'iconPrimary',
};
